import React from 'react';

interface NavItem {
  icon: string;
  label: string;
  active?: boolean;
  onClick?: () => void;
}

interface NavBarProps {
  items: NavItem[];
  className?: string;
}

export function NavBar({ items, className = '' }: NavBarProps) {
  return (
    <div className={`app-navbar ${className}`}>
      {items.map((item, index) => (
        <div
          key={index}
          onClick={item.onClick}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
            cursor: 'pointer',
            opacity: item.active ? 1 : 0.4,
            color: item.active ? 'var(--app-accent)' : '#333',
          }}
        >
          <span style={{ fontSize: 20 }}>{item.icon}</span>
          <span style={{ fontSize: 10, fontWeight: 600, letterSpacing: 0.3 }}>{item.label}</span>
        </div>
      ))}
    </div>
  );
}
